var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"share_img_wrap",on:{"click":_vm.openShareModal}},[_c('div',{staticClass:"share_img"})])
}
var staticRenderFns = []

export { render, staticRenderFns }